import { computed, onUnmounted, ref, watch } from 'vue';
import {
  formatRemainingTime,
  getRemainingSeconds,
} from 'dashboard/helper/messagingWindowHelper';

export const useMessagingWindowTimer = expiresAtRef => {
  const remainingSeconds = ref(getRemainingSeconds(expiresAtRef.value));
  let intervalId = null;

  const clearTimer = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const syncRemainingSeconds = () => {
    remainingSeconds.value = getRemainingSeconds(expiresAtRef.value);
  };

  const startTimer = () => {
    clearTimer();

    if (!expiresAtRef.value) {
      remainingSeconds.value = 0;
      return;
    }

    syncRemainingSeconds();
    intervalId = setInterval(syncRemainingSeconds, 1000);
  };

  watch(expiresAtRef, startTimer, { immediate: true });

  onUnmounted(clearTimer);

  const formattedTime = computed(() =>
    formatRemainingTime(remainingSeconds.value)
  );

  const isExpired = computed(() => remainingSeconds.value <= 0);

  const urgency = computed(() => {
    if (remainingSeconds.value <= 3600) return 'critical';
    if (remainingSeconds.value <= 4 * 3600) return 'warning';
    return 'normal';
  });

  return {
    remainingSeconds,
    formattedTime,
    isExpired,
    urgency,
  };
};
